import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

type UserAssignConfirmationProps = {
  open: boolean;
  handleClose: () => void;
  onSubmit: () => void;
  userName?: string;
  type: 'add' | 'remove';
  loader?: boolean;
};
const UserAssignConfirmation: React.FC<UserAssignConfirmationProps> = ({
  open,
  handleClose,
  onSubmit,
  userName,
  type,
  loader,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loader ? undefined : handleClose}
      PaperProps={{
        style: {
          borderRadius: '12px',
          display: 'flex',
          height: '200px',
          justifyContent: 'center',
          maxWidth: 600,
          width: '100%',
        },
      }}>
      <IconButton
        aria-label="close"
        onClick={loader ? undefined : handleClose}
        sx={{
          '&:hover': { backgroundColor: '#f3f4f6' },
          color: '#6b7280',
          position: 'absolute',
          right: 8,
          top: 8,
        }}>
        <CloseIcon />
      </IconButton>
      <DialogTitle
        sx={{
          color: '#111827',
          fontFamily: 'Red Hat Display SemiBold',
          fontSize: '18px',
          position: 'relative',
          pr: '48px',
          pt: '24px',
        }}>
        <Typography
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}>
          {`Are you sure you want to ${
            type === 'add' ? 'add' : 'remove'
          } this user ${userName || ''}?`}
        </Typography>
      </DialogTitle>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          disabled={loader}
          onClick={handleClose}
          sx={{
            '&:disabled': {
              opacity: 0.6,
            },
            '&:hover': {
              backgroundColor: '#f9fafb',
              borderColor: '#d1d5db',
            },
            backgroundColor: '#ffffff',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            color: '#374151',
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px',
            fontWeight: '600',
            minWidth: '100px',
            padding: '8px 20px',
            textTransform: 'none',
          }}>
          No, Cancel
        </Button>
        <Button
          disabled={loader}
          startIcon={
            loader ? (
              <CircularProgress size={20} sx={{ color: 'white' }} />
            ) : null
          }
          onClick={onSubmit}
          sx={{
            '&:disabled': {
              backgroundColor: '#dc2626',
              opacity: 0.6,
            },
            '&:hover': {
              backgroundColor: '#b91c1c',
            },
            backgroundColor: '#dc2626',
            borderRadius: '6px',
            color: '#ffffff',
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px',
            fontWeight: '600',
            minWidth: '120px',
            padding: '8px 20px',
            textTransform: 'none',
          }}>
          {`Yes, ${type === 'add' ? 'Add User' : 'Remove User'}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserAssignConfirmation;
